export default "__VITE_ASSET__jtda_H$T__"